// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[v-cloak][data-v-461c6289] {\n\tdisplay: none;\n}\n.grid-row[data-v-461c6289] {\n\tdisplay: grid;\n\tgrid-template-columns: 8fr 4fr;\n\talign-items: center;\n}\n.controls[data-v-461c6289] {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n}\n\t\n", ""]);
// Exports
module.exports = exports;
